import React from 'react'

export const Aboutus = () => {
  return (
    <div>Aboutus</div>
  )
}
